import { RefundOfferIdDto } from 'types/dtos/refund-offer-id'

import { api } from './api'

export const getRefundOfferId = (complaintId: number) =>
  api.get<RefundOfferIdDto>(`/complaints/${complaintId}/refund_offer_id`)
